import { render } from "./Login2FA.vue?vue&type=template&id=f427cdd0&scoped=true"
import script from "./Login2FA.vue?vue&type=script&lang=js"
export * from "./Login2FA.vue?vue&type=script&lang=js"

import "./Login2FA.vue?vue&type=style&index=0&id=f427cdd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f427cdd0"]])

export default __exports__